var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({staticClass:"p-theme-button",class:{ outlined: _vm.outlined || _vm.text, text: _vm.text, block: _vm.block, fullWidth: _vm.fullWidth }},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }